export const SAVE_ALL_EMPLOYEES = 'SAVE_ALL_EMPLOYEES'
